<template>
  <v-dialog
    v-model="showContactFormDialog"
    scrollable
    max-width="552px"
    persistent
  >
    <v-card v-if="showContactFormDialog">
      <v-card-title class="primary white--text">
        <h3 class="headline">{{ $t('content.contact.label') }}</h3>
        <v-spacer/>
        <v-btn text small fab @click.native="showContactFormDialog = false">
          <v-icon color="white">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <form>
          <v-container class="pa-0 ma-0" grid-list-md>
            <v-row>
              <v-col class="text-center" v-html="$t('content.contact.importantQuestions')"/>
            </v-row>
            <v-row>
              <v-col class="text-center">
                <v-btn
                  color="primary" outlined
                  :to="{ name: 'page.find-a-job', hash: '#section-4', params: { lang: this.language } }"
                  @click="showContactFormDialog = false"
                >
                  {{ $t('content.contact.employees') }}
                </v-btn>
                <v-btn
                  color="primary" outlined
                  :to="{ name: 'page.job-advertisement', hash: '#section-5', params: { lang: this.language } }"
                  @click="showContactFormDialog = false"
                >
                  {{ $t('content.contact.employers') }}
                </v-btn>
              </v-col>
            </v-row>
            <v-divider class="my-3"/>
            <v-row>
              <v-col class="text-center"  v-html="$t('content.contact.cantSolveProblem')"/>
            </v-row>
            <v-row>
              <v-col :cols="12" :sm="6" class="py-0">
                <v-autocomplete
                  v-model="form.sex"
                  :items="salutationItems"
                  :label="$t('texts.salutation')"
                  item-text="text"
                  item-value="value"
                  required
                  :error-messages="errors.collect('salutation')"
                  v-validate="'required'"
                  data-vv-name="salutation"
                  :data-vv-as="$t('texts.salutation')"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col :cols="12" :sm="6" class="py-0">
                <v-text-field
                  :label="$t('texts.firstName')"
                  value=""
                  v-model="form.first_name"
                  required
                  :error-messages="errors.collect('firstName')"
                  v-validate="'required'"
                  data-vv-name="firstName"
                  :data-vv-as="$t('texts.firstName')"
                />
              </v-col>
              <v-col :cols="12" :sm="6" class="py-0">
                <v-text-field
                  :label="$t('texts.lastName')"
                  v-model="form.last_name"
                  required
                  :error-messages="errors.collect('lastName')"
                  v-validate="'required'"
                  data-vv-name="lastName"
                  :data-vv-as="$t('texts.lastName')"
                />
              </v-col>
            </v-row>
            <v-row v-if="!authUser.is_employee">
              <v-col :cols="12" class="py-0">
                <v-text-field
                  v-model="form.company_name"
                  :label="$t('texts.nameOfCompany')"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col :cols="12" class="py-0">
                <v-text-field
                  :label="$t('texts.email')"
                  v-model="form.email"
                  required
                  :error-messages="errors.collect('userProfile.email')"
                  v-validate="'required|email'"
                  data-vv-name="userProfile.email"
                  :data-vv-as="$t('texts.email')"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0">
                <v-textarea
                  v-model="form.message"
                  :label="$t('texts.yourConcern')"
                  required
                  :error-messages="errors.collect('message')"
                  v-validate="'required'"
                  data-vv-name="message"
                  :data-vv-as="$t('texts.yourConcern')"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </form>
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          color="primary"
          @click="submitForm()"
          :disabled="buttonLoading"
          :loading="buttonLoading"
        >
          {{ $t('texts.send') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState: mapUserState, mapActions: mapUserActions } = createNamespacedHelpers('user');
const { mapActions: mapMessageActions } = createNamespacedHelpers('messages');

export default {
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      showContactFormDialog: false,
      buttonLoading: false,
      form: {},
    };
  },
  mounted() {
    this.$eventBus.$on('show-contact-form-dialog', () => {
      this.reset();
      this.showContactFormDialog = true;
    });
  },
  computed: {
    ...mapUserState([
      'authUser',
      'language',
    ]),
    salutationItems() {
      const items = [
        { value: 1, text: this.$i18n.t('texts.salutationMr') },
        { value: 2, text: this.$i18n.t('texts.salutationMrs') },
      ];
      return items;
    },
  },
  methods: {
    ...mapUserActions([
      'sendContactForm',
    ]),
    ...mapMessageActions([
      'showMessageValidateError',
    ]),
    reset() {
      this.form = {
        sex: 1,
        first_name: '',
        last_name: '',
        company_name: '',
        email: '',
        message: '',
      };
    },
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.buttonLoading = true;
          this.sendContactForm(this.form)
            .then(() => {
              this.buttonLoading = false;
              this.showContactFormDialog = false;
            }).catch(() => {
              this.buttonLoading = false;
            });
        } else {
          this.showMessageValidateError();
        }
      });
    },
  },
};
</script>
